export function mergeBackendThreads(localThreads = [], backendThreads = []) {
  const localById = new Map(localThreads.map((thread) => [thread.id, thread]))
  const backendIds = new Set(backendThreads.map((thread) => thread.id))
  const mergedBackend = backendThreads.map((thread) => ({
    ...(localById.get(thread.id) ?? {}),
    ...thread,
  }))
  const localOnly = localThreads.filter((thread) => !backendIds.has(thread.id))
  return [...mergedBackend, ...localOnly]
}
